import { registerEnum } from '@adornis/baseql/metadata/register.js';

export enum ParticipationState {
  participated = 'participated',
  in = 'in',
  left = 'left',
  waiting = 'waiting',
  suspended = 'suspended',
  no_show = 'no_show',
}
registerEnum({ enum: ParticipationState, name: 'ParticipationState' });

export enum ProductRuntimeState {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  PLANNED = 'PLANNED',
}

registerEnum({ enum: ProductRuntimeState, name: 'ProductRuntimeState' });

export enum Anbieter {
  frankfurt_uas = 'frankfurt_uas',
  goethe = 'goethe',
  hs_darmstadt = 'hs_darmstadt',
  hs_rheinmain = 'hs_rheinmain',
  jgu_mainz = 'jgu_mainz',
  tu_darmstadt = 'tu_darmstadt',
  agentur_fuer_arbeit = 'agentur_fuer_arbeit',
  sonstige = 'sonstige',
}
registerEnum({ enum: Anbieter, name: 'Anbieter' });
